type FabricModule = typeof import('fabric');

let fabricModule: FabricModule | null = null;
let loadPromise: Promise<FabricModule> | null = null;

/**
 * 懒加载 Fabric.js，全局共享同一份模块实例，避免重复下载与解析。
 */
export function loadFabric(): Promise<FabricModule> {
  if (fabricModule) {
    return Promise.resolve(fabricModule);
  }
  if (!loadPromise) {
    loadPromise = import('fabric').then((mod) => {
      fabricModule = mod;
      return fabricModule;
    });
  }
  return loadPromise;
}

/**
 * 在空闲时预加载 Fabric.js，缩短首次打开画布组件的等待时间。
 */
export function prefetchFabric() {
  const run = () => {
    void loadFabric();
  };
  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(run);
  } else {
    setTimeout(run, 200);
  }
}
